import { defineMessages } from 'react-intl'

const scope = 'app.components.ZoneModal'

export default defineMessages({
  header: {
    id: `${scope}.header`,
    defaultMessage:
      '{mode, select, create {Create a new} edit {Edit} delete {Delete} other {}} Zone{mode, select, view {:{name}} other {}}',
  },
  labels: {
    slug: {
      id: `${scope}.labels.slug`,
      defaultMessage: 'Slug',
    },
    name: {
      id: `${scope}.labels.name`,
      defaultMessage: 'Zone Name',
    },
    verticals: {
      id: `${scope}.labels.verticals`,
      defaultMessage: 'Verticals',
    },
    groups: {
      id: `${scope}.labels.groups`,
      defaultMessage: 'Groups',
    },
  },
})
